import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Grid, Box} from '@mui/material';
import apiCall, {setUserToken} from '@/utils/api';
import Loader from '@/shared/Loader';
import RecreationalCenters from 'src/containers/FdcMilanoGroupActivities/Charts/RecreationalCenters';
import CollectiveActivities from 'src/containers/FdcMilanoGroupActivities/Charts/CollectiveActivities';
import PercentageBeneficiaries from 'src/containers/FdcMilanoGroupActivities/Charts/PercentageBeneficiaries';
import {ISubmissionProps} from '@/containers/FdcMilanoGroupActivities/resources/submission';

import './styles.scss';

const FdcMilanoGroupActivities = () => {
    const [searchParams] = useSearchParams();
    const container = searchParams.get('container_id');
    const collectiveActivitySurvey  = searchParams.get('collective_activity_survey');
    const monitoringProfileSurvey = searchParams.get('monitoring_profile_survey');

    setUserToken(searchParams.get('token') || '')

    const [loading, setLoading] = useState<boolean>(true);
    const [collectiveActivitySubmissions, setCollectiveActivitySubmissions] = useState<ISubmissionProps[]>([]);
    const [monitoringProfileSubmissions, setMonitoringProfileSubmissions] = useState<ISubmissionProps[]>([]);

    const getSurvey = async () => {
        try {
            const responses = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: collectiveActivitySurvey,
                    completed: 1,
                    additional_data: false,
                },
            });
            const responsesMonitoringProfile = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: monitoringProfileSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });

            setCollectiveActivitySubmissions(responses.data.submissions);
            setMonitoringProfileSubmissions(responsesMonitoringProfile.data.submissions);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        getSurvey().then(() => setLoading(false));
    }, []);

    return (
        <Box p={2}>
            {
                !loading && (
                    <>
                        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>
                            <Grid item xs={6}>
                                <RecreationalCenters
                                    submissions={collectiveActivitySubmissions}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CollectiveActivities
                                    submissions={monitoringProfileSubmissions}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <PercentageBeneficiaries
                                    submissions={collectiveActivitySubmissions}
                                />
                            </Grid>
                        </Grid>
                    </>
                )
            }
            {
                loading && (
                    <Box className='loader-container'>
                        <Loader size={60}/>
                    </Box>
                )
            }
        </Box>
    )
}

export default FdcMilanoGroupActivities;